<div class="selector-div-wrapper">
  <span>VR</span>
  <div class="form-check form-switch">
    <input class="input-switch-sm form-check-input" type="checkbox" role="switch" id="vr-switch"
      (change)="onSelect($event)" [(ngModel)]="tool.enabled" [checked]="tool.enabled">
  </div>
</div>